import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useProfileStore } from '../../state/profileStore';

export default function ProtectedRoute({ children /*, deferWhileLoading*/ }) {
  const location = useLocation();
  const profile = useProfileStore((s) => s.profile);

  // Not authenticated → bounce to home (login modal can be opened from there)
  if (!profile) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Authenticated → render the protected page
  return children;
}
